angular.module('satv.playlist.pitch')

.factory('PitchEditModal', ['config', 'Modal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/playlists/modals/pitch-edit',
                params,
                data
            );
        }
    };
}])

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/PitchEditModal.js